const getPageSizeFromMapping = (sizes) => {
	const h = window.innerHeight;

	for (const { max, size } of sizes) {
		if (h < max) return size;
	}

	return 20;
};

export function getPageSize() {
	const sizes = [
		{ max: 600, size: 4 },
		{ max: 700, size: 6 },
		{ max: 750, size: 8 },
		{ max: 800, size: 9 },
		{ max: 850, size: 10 },
		{ max: 900, size: 11 },
		{ max: 950, size: 12 },
		{ max: 1000, size: 13 },
		{ max: 1050, size: 14 },
		{ max: 1100, size: 15 },
	];

	return getPageSizeFromMapping(sizes);
}

export function getPageSize2() {
	const sizes = [
		{ max: 600, size: 8 },
		{ max: 700, size: 9 },
		{ max: 750, size: 10 },
		{ max: 800, size: 11 },
		{ max: 850, size: 12 },
		{ max: 900, size: 13 },
		{ max: 950, size: 14 },
		{ max: 1000, size: 15 },
		{ max: 1050, size: 16 },
		{ max: 1100, size: 17 },
		{ max: 1150, size: 18 },
		{ max: 1200, size: 19 },
		{ max: 1250, size: 20 },
		{ max: 1300, size: 22 },
		{ max: 1350, size: 24 },
	];

	return getPageSizeFromMapping(sizes);
}

export function getPageSizeSmall2() {
	const sizes = [
		{ max: 600, size: 4 },
		{ max: 700, size: 5 },
		{ max: 750, size: 6 },
		{ max: 850, size: 7 },
		{ max: 950, size: 8 },
		{ max: 1050, size: 9 },
		{ max: 5000, size: 10 },
	];

	return getPageSizeFromMapping(sizes);
}

export function getPageSizeSmall() {
	const sizes = [
		{ max: 600, size: 6 },
		{ max: 700, size: 8 },
		{ max: 800, size: 10 },
		{ max: 900, size: 12 },
		{ max: 1000, size: 14 },
		{ max: 1100, size: 16 },
		{ max: 1200, size: 18 },
		{ max: 1300, size: 20 },
		{ max: 1400, size: 22 },
	];

	return getPageSizeFromMapping(sizes);
}



// WEBPACK FOOTER //
// ./src/utils/paging.js